import { useTranslation } from 'react-i18next';

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 sm:py-28 md:py-36 overflow-hidden bg-gray-950">
      {/* Background image with dark overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=dark%20cinematic%20home%20theater%20room%20with%20large%20screen%20glowing%20in%20darkness%2C%20deep%20black%20and%20navy%20tones%2C%20dramatic%20ambient%20lighting%2C%20ultra%20wide%20angle%2C%20moody%20atmosphere%2C%20no%20people%2C%20minimalist%20luxury%20interior&width=1440&height=600&seq=cta-bg-001&orientation=landscape"
          alt="Premium streaming"
          className="w-full h-full object-cover object-center"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-gray-950/80 via-gray-950/70 to-gray-950/90" />
        <div className="absolute inset-0 bg-gradient-to-r from-gray-950/60 via-transparent to-gray-950/60" />
      </div>

      {/* Glow accents */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[300px] bg-[#0ea5e9]/10 rounded-full blur-[120px] pointer-events-none z-0" />

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-emerald-500/15 border border-emerald-500/30 text-emerald-400 px-4 py-1.5 rounded-full text-xs font-semibold mb-6 sm:mb-8">
          <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse inline-block" />
          {t('cta.note')}
        </div>

        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-white mb-4 sm:mb-6 leading-tight tracking-tight">
          {t('cta.title')}
        </h2>
        <p className="text-base sm:text-lg md:text-xl text-gray-300 mb-8 sm:mb-10 max-w-2xl mx-auto leading-relaxed">
          {t('cta.desc')}
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a
            href="#test"
            className="group relative w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-gradient-to-r from-[#0284c7] to-[#0ea5e9] hover:from-[#0369a1] hover:to-[#0284c7] text-white font-bold text-base sm:text-lg px-10 py-4 sm:py-5 rounded-full transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap overflow-hidden"
          >
            <div className="absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-1000 bg-gradient-to-r from-transparent via-white/20 to-transparent" />
            <i className="ri-gift-line relative z-10" />
            <span className="relative z-10">{t('cta.btn1')}</span>
          </a>
          <a
            href="https://wa.me/12089746525"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 border-2 border-white/20 hover:border-[#25D366] text-white hover:text-[#25D366] font-semibold text-base sm:text-lg px-10 py-4 sm:py-5 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-whatsapp-line" />
            {t('cta.btn2')}
          </a>
        </div>

        {/* Trust badges */}
        <div className="mt-10 sm:mt-12 flex flex-wrap justify-center gap-4 sm:gap-8">
          {[
            { icon: 'ri-shield-check-line', text: '7-Day Guarantee', color: 'text-emerald-400' },
            { icon: 'ri-flashlight-line', text: 'Instant Activation', color: 'text-amber-400' },
            { icon: 'ri-lock-line', text: 'Secure Payment', color: 'text-[#7dd3fc]' },
            { icon: 'ri-customer-service-2-line', text: '24/7 Support', color: 'text-pink-400' },
          ].map(({ icon, text, color }) => (
            <div key={text} className="flex items-center gap-2 text-gray-400 text-sm">
              <i className={`${icon} ${color} text-base`} />
              <span>{text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
